const SHARED_DRIVE_ID = "0AAGGRVHagmM6Uk9PVA";
const FOLDER_OPPORTUNITY = "1rJkz-jkakKohulTihyBMuZEURWgWSSSr";
const FOLDER_OPERATIONS = "1QSxZIRkLASZ9FFGNMk7Sx0u9dzQCZMCO";
const CARTELLA_TEMPLATE = "1kaq5V2Gv4ilXL7c7QSb49qLkWytmu2tj";

export function formatNomeCartella(dataInizio, titolo) {
  const data = dataInizio || "";
  const titoloClean = titolo
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");
  return `${data}_${titoloClean}`;
}

async function cercaCartella(accessToken, nome, parentId) {
  const query = `name='${nome}' and '${parentId}' in parents and mimeType='application/vnd.google-apps.folder' and trashed=false`;
  const url = `https://www.googleapis.com/drive/v3/files?q=${encodeURIComponent(query)}&supportsAllDrives=true&includeItemsFromAllDrives=true&driveId=${SHARED_DRIVE_ID}&corpora=drive`;
  console.log("cercaCartella:", { nome, parentId });
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const data = await res.json();
  console.log("Risultato cercaCartella:", data);
  return data.files?.[0] || null;
}

async function creaCartella(accessToken, nome, parentId) {
  console.log("creaCartella:", { nome, parentId });
  const res = await fetch("https://www.googleapis.com/drive/v3/files?supportsAllDrives=true", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name: nome,
      mimeType: "application/vnd.google-apps.folder",
      parents: [parentId],
      driveId: SHARED_DRIVE_ID,
    }),
  });
  const data = await res.json();
  console.log("Risultato creaCartella:", data);
  return data.id;
}

async function copiaContenutoTemplate(accessToken, templateId, destinazioneId) {
  const listaUrl = `https://www.googleapis.com/drive/v3/files?q='${templateId}'+in+parents+and+trashed=false&supportsAllDrives=true&includeItemsFromAllDrives=true&fields=files(id,name,mimeType)`;
  const listaRes = await fetch(listaUrl, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const listaData = await listaRes.json();
  console.log("Contenuto template:", listaData);

  for (const item of listaData.files || []) {
    if (item.mimeType === "application/vnd.google-apps.folder") {
      const nuovaSottocartella = await creaCartella(accessToken, item.name, destinazioneId);
      await copiaContenutoTemplate(accessToken, item.id, nuovaSottocartella);
    } else {
      const copiaUrl = `https://www.googleapis.com/drive/v3/files/${item.id}/copy?supportsAllDrives=true`;
      const copiaRes = await fetch(copiaUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: item.name,
          parents: [destinazioneId],
        }),
      });
      const copiaData = await copiaRes.json();
      console.log(`File copiato: ${item.name}`, copiaData);
    }
  }
}

async function getOCreaCartellaCliente(accessToken, nomeCliente, parentId) {
  console.log("getOCreaCartellaCliente:", { nomeCliente, parentId });
  let cartella = await cercaCartella(accessToken, nomeCliente, parentId);
  if (!cartella) {
    console.log("Cartella cliente non trovata, la creo...");
    const id = await creaCartella(accessToken, nomeCliente, parentId);
    return id;
  }
  console.log("Cartella cliente trovata:", cartella.id);
  return cartella.id;
}

export async function creaCartellaEvento(accessToken, nomeCliente, dataInizio, titolo, stato) {
  const nomeCartella = formatNomeCartella(dataInizio, titolo);
  const parentBase = stato === "chiusoAcquisito" ? FOLDER_OPERATIONS : FOLDER_OPPORTUNITY;
  console.log("creaCartellaEvento:", { nomeCartella, parentBase, stato });

  const cartellaClienteId = await getOCreaCartellaCliente(accessToken, nomeCliente, parentBase);

  let cartellaEvento = await cercaCartella(accessToken, nomeCartella, cartellaClienteId);
  if (cartellaEvento) {
    console.log("Cartella evento già esistente:", cartellaEvento.id);
    return `https://drive.google.com/drive/folders/${cartellaEvento.id}`;
  }

  const cartellaEventoId = await creaCartella(accessToken, nomeCartella, cartellaClienteId);
  console.log("Cartella evento creata:", cartellaEventoId);

  // Copia struttura dal template
  await copiaContenutoTemplate(accessToken, CARTELLA_TEMPLATE, cartellaEventoId);
  console.log("Struttura template copiata");

  return `https://drive.google.com/drive/folders/${cartellaEventoId}`;
}

export async function spostaCartellaAdAcquisito(accessToken, nomeCliente, cartellaDriveUrl) {
  console.log("spostaCartellaAdAcquisito chiamata", { nomeCliente, cartellaDriveUrl });

  const match = cartellaDriveUrl.match(/folders\/([a-zA-Z0-9_-]+)/);
  if (!match) {
    console.error("URL cartella non valido:", cartellaDriveUrl);
    return cartellaDriveUrl;
  }
  const cartellaEventoId = match[1];

  // Recupera il parent attuale della cartella evento
  const infoUrl = `https://www.googleapis.com/drive/v3/files/${cartellaEventoId}?fields=name,parents&supportsAllDrives=true`;
  const infoRes = await fetch(infoUrl, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const infoData = await infoRes.json();
  console.log("Info cartella evento:", infoData);

  const vecchioParentId = infoData.parents?.[0];
  if (!vecchioParentId) {
    console.error("Parent non trovato");
    return cartellaDriveUrl;
  }

  // Trova o crea la cartella cliente in Operations
  const cartellaClienteOperationsId = await getOCreaCartellaCliente(
    accessToken, nomeCliente, FOLDER_OPERATIONS
  );
  console.log("ID cartella cliente in Operations:", cartellaClienteOperationsId);

  // Sposta la cartella evento cambiando il parent (senza creare nulla di nuovo)
  const spostaUrl = `https://www.googleapis.com/drive/v3/files/${cartellaEventoId}?addParents=${cartellaClienteOperationsId}&removeParents=${vecchioParentId}&supportsAllDrives=true&fields=id,parents`;
  const spostaRes = await fetch(spostaUrl, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
  const spostaData = await spostaRes.json();
  console.log("Cartella spostata:", spostaData);

  if (spostaData.error) {
    console.error("Errore spostamento cartella:", spostaData.error);
    return cartellaDriveUrl;
  }

  return `https://drive.google.com/drive/folders/${cartellaEventoId}`;
}